import React from "react";

const Header = () => {
    return(
        <section className="titles-section gridrowfull">
            <div className="titles col-12">
                <h1 className="col-12">Catalog</h1>
                <h2 className="col-12">Our Products</h2>
            </div>
        </section>
    );
}

export default Header;